export const NotRelevant = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g opacity=".4">
				<circle cx="8" cy="8" r="8" fill="#7EA6B4" />
				<rect x="4" y="7" width="8" height="2" rx="1" fill="#fff" />
			</g>
		</svg>
	);
};
